/* @ngdoc object
 * @name guestlists
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./guestlists-routes');

// Controllers
require('./controllers/guestlists/seats/do-booking-modal-controller');
require('./controllers/guestlists/seats/add-element-modal-controller');
require('./controllers/guestlists/seats/booking-information-modal-controller');
require('./controllers/guestlists/seats/public-seats-controller');
require('./controllers/guestlists/seats/move-to-other-list/main-controller');

require('./controllers/pages/rsvps/rsvps-create-controller');
require('./controllers/rsvps/rsvps-masterlist-controller');

require('./controllers/rsvps/store/extended-listview');
require('./controllers/rsvps/store/duplicates-extended-listview');

// Directives
require('./directives/checkin/checkin-directive');
require('./components/messages/rsvp-messages');
require('./components/extended-info/rsvp-extended-info');
require('./components/rsvp-guests-full/component');
require('./components/rsvp-relations/component');

// Factories
require('./factories/guestlist/guestlist-factory');
require('./factories/guestlist/guestlist-shift-factory');
require('./factories/rsvp/rsvp-factory');
require('./factories/checkin-factory');

// Services
require('./services/guestlist-action-service');

// Store
require('./store/guestlists');
require('./store/shifts');
require('./store/rsvps');
require('./store/rsvp-duplicates');

// Workflows
require('./workflows/general/create-rsvp');
require('./workflows/general/add-rsvp-to-guestlists');
require('./workflows/general/add-rsvps-to-categories');
require('./workflows/general/add-rsvps-to-picklists');
require('./workflows/general/add-to-addressbook');
require('./workflows/general/archive-selected-rsvps');
require('./workflows/general/export-files');
require('./workflows/general/export-rsvps');
require('./workflows/general/export-all-rsvps');
// require('./workflows/general/import-rsvps');
require('./workflows/general/genderize-rsvps');
require('./workflows/general/duplicate-guestlist');
require('./workflows/general/duplicate-guestlists');
require('./workflows/general/merge-selected-rsvps');
require('./workflows/general/masterlist');
require('./workflows/general/remove-rsvps-from-categories');
require('./workflows/general/remove-rsvps-from-picklists');
require('./workflows/general/send-rsvp-email');
require('./workflows/general/send-rsvp-sms');
require('./workflows/general/update-rsvps');
require('./workflows/general/view-bookings');
require('./workflows/general/view-seatmap');
require('./workflows/general/email-rsvps');
// require('./workflows/general/edit-guestlist-settings');
// require('./workflows/general/guestlist-release-settings');
// require('./workflows/general/edit-landingpage-settings');
require('./workflows/heart-me/quick-add-contact');
require('./workflows/heart-me/quick-add-guest-custom');
require('./workflows/general/detailed/edit-rsvp');
require('./workflows/general/detailed/archive-rsvp');
require('./workflows/general/detailed/restore-rsvp');
require('./workflows/general/detailed/delete-rsvp');
require('./workflows/general/detailed/email-rsvp');
require('./workflows/general/detailed/sms-rsvp');
require('./workflows/general/detailed/add-rsvp-to-addressbook');

require('./workflows/general/detailed/checkin-rsvp');
require('./workflows/general/create-guestlist');

require('./workflows/general/rsvps-list/toggle-guest-mode');
// require('./workflows/general/rsvps-list/show-duplicates');
// require('./workflows/general/rsvps-list/guestlist-limits');
require('./workflows/general/rsvps-list/create-and-print-tickets-for-rsvps');
require('./workflows/general/rsvps-list/print-overview-documents-for-rsvps');
require('./workflows/general/rsvps-list/update-status');
require('./workflows/general/rsvps-list/create-document-for-rsvps');
require('./workflows/general/rsvps-list/go-to-seatplan');
require('./workflows/general/rsvps-list/copy-rsvps-to-other-lists');



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/guestlists-module.js